import React from 'react'
import styled from 'styled-components'
import { AnimatedContentLoader } from '../AnimatedContentLoader'
import { TagPill } from '../TagPill'
import { useTags } from '@root/query'

interface Props {
  tagIds?: number[]
  label?: React.ReactNode
}

export const TagDisplay: React.FC<Props> = ({ tagIds, label }) => {
  const { data, isLoading } = useTags({ tagIds: tagIds })
  const tags = data?.results || []

  return (
    <StyledContainer>
      {label && label}
      <AnimatedContentLoader isLoading={isLoading} isEmpty={tags.length === 0}>
        <StyledTagContainer>
          {tags.map(tag => (
            <TagPill key={tag.id} tag={tag} maxWidth={'100%'} />
          ))}
        </StyledTagContainer>
      </AnimatedContentLoader>
    </StyledContainer>
  )
}

const StyledTagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
`

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`
